import { render, staticRenderFns } from "./CollectablePie.vue?vue&type=template&id=2f57a776&scoped=true&"
import script from "./CollectablePie.vue?vue&type=script&lang=js&"
export * from "./CollectablePie.vue?vue&type=script&lang=js&"
import style0 from "./CollectablePie.vue?vue&type=style&index=0&id=2f57a776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f57a776",
  null
  
)

export default component.exports